import dynamic from 'next/dynamic';

export const FeedVideoCard = dynamic(
  () => import('./feedVideoCardInternal').then((mod) => mod.FeedVideoCard),
  { ssr: false }
);
